export default __webpack_public_path__ + "static/media/intro.47d76126.svg";